// Central palette — used via inline styles to stay immune to the preview
// overlay's bg-opacity handling. Import { C } and use style={{ background: C.teal }}.
export const C = {
  bg: '#F3F5F1',
  card: '#FFFFFF',
  ink: '#202821',
  inkSoft: '#565F58',
  line: '#A6ADA3',
  lineSoft: '#D7DBD3',
  teal: '#2C5A4E',
  tealDeep: '#20463C',
  gold: '#B98B3A',
  goldSoft: '#F1E6CE',
  plum: '#6B4A63',
  plumSoft: '#EDE4EC',
  tealSoft: '#E1EAE5',
};

// Tint helper for soft backgrounds.
export const tint = {
  teal: '#E1EAE5',
  gold: '#F5ECD8',
  plum: '#EDE4EC',
};
